export default "__VITE_ASSET__67QG5Ayo__"